import boxLinesImg from "../assets/box-text-lines.png";
import boxMessagesImg from "../assets/box-messges.png";
import boxRobotImg from "../assets/box-robot.png";

export const featuresData = [
  {
    title: "Meet Angel",
    desc: "Tailor your CV to match job descriptions and land your dream job with Angel..",
    subTitle: "Perfect CV Re-write in Minutes",
    img: boxLinesImg,
    link: "/chat-angel",
  },
  {
    title: "Speak with Alfred",
    desc: "Get covered with instant insights and practical solutions on workflow and campaign optimization",
    subTitle: "24/7 Expert Marketing Operations Assistant",
    img: boxMessagesImg,
    link: "/chat-alferd",
  },
  {
    title: "Prep Interviews with Anita",
    desc: "Prepare for interviews with real-time simulations, feedback and improvement tips tailored to your role.",
    subTitle: "Your AI-Powered Interview Coach",
    img: boxRobotImg,
    link: "/chat-anita",
  },
];
